import { httpClient } from '@/services/http/httpClient'
import type { IdeaFieldFormat } from '@/types/ideaFieldsFormat'
import type { Option } from '@/types/option'
import { generateSlug } from '@/utils/generateSlug'

type IdeaFieldHttpResponse = {
  id: string
  tennantId: string
  ideaId: string | null
  campaignId: string
  parentIdeaFieldId: string | null
  title: string
  name: string
  description: string
  type: IdeaFieldFormat
  options: { name: string }[]
  sequence: number
  status: string
  createdAt: string
  obligatoriness: string
}

type IdeaFieldsHttpResponse = {
  ideaFields: IdeaFieldHttpResponse[]
}

type Params = {
  challengeId: string
}

export type IdeaField = {
  id: string
  tenantId: string
  challengeId: string
  ideaId: string | null
  parentIdeaFieldId: string | null
  title: string
  slug: string
  description: string
  format: IdeaFieldFormat
  options: Option[]
  sequence: number
  status: string
  createdAt: string
  mandatory: boolean
}

export async function getFields({ challengeId }: Params): Promise<IdeaField[]> {
  const { data } = await httpClient.get<IdeaFieldsHttpResponse>(
    `/ideas/campaigns/${challengeId}/idea-form`,
  )

  const { ideaFields = [] } = data

  return ideaFields.map((ideaField) => {
    const {
      id,
      tennantId,
      campaignId,
      ideaId,
      parentIdeaFieldId,
      title,
      name,
      description,
      type,
      options = [],
      sequence,
      status,
      createdAt,
      obligatoriness,
    } = ideaField

    // todo: esse fix não deve ser no front, deve vir formatado do back
    const optionsAsArray =
      typeof options === 'string' ? JSON.parse(options ?? '[]') : options

    // todo: Implementar slug no back
    const slug = generateSlug(name)

    return {
      id,
      tenantId: tennantId,
      ideaId,
      parentIdeaFieldId,
      challengeId: campaignId,
      title,
      slug,
      description,
      format: type,
      options:
        optionsAsArray?.map(({ name = '' }) => ({
          label: name,
          value: name,
        })) ?? [],
      sequence,
      status,
      createdAt,
      mandatory: obligatoriness === 'MANDATORY',
    } as IdeaField
  })
}
